module.exports = __webpack_public_path__ + "img/1F3F3-FE0F-200D-1F308.3dae669a.svg";